import { PropertyOwnerDto } from "../../api/types";

function formatPropertyOwnerName(owner?: Partial<PropertyOwnerDto> | null) {
  return [owner?.firstName, owner?.lastName].join(" ");
}

export default formatPropertyOwnerName;
